import React from 'react';

import { shouldSetPreviousUrl } from '~commonInfra/url/UrlHelpers';
import { setPreviousUrl } from '~src/bootstrap/redux/actions/SetPreviousUrlReducerAction';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { useEffectOnUrlChange } from '~src/root/hooks/UseEffectOnUrlChange';
import { VizServiceContext } from '~src/viz/services/VizService';

export function useSetPreviousUrlHandler() {
  const vizService = React.useContext(VizServiceContext);

  useEffectOnUrlChange((newUrl, oldUrl) => {
    if(shouldSetPreviousUrl(oldUrl, newUrl, vizService)) {
      // setting the previous url here keeps the sorts and filter parameters in the url
      getAppStore().dispatch(setPreviousUrl(oldUrl));
    }
  }, [vizService]);
}
